import React from 'react';
import { Dialog, DialogTitle, DialogContent, Grid } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import messages from 'containers/RecapManagerPage/messages';
import { translate } from 'containers/services/translate';
import {
  StyleDescriptionDialog,
  StyledDialogActions,
} from 'containers/RecapManagerPage/styled-components';
import CloseIconBlack from 'components/SahamIcons/CloseIconBlack';
import { COLORS } from 'constants/design';
export interface ConfirmationDialogProps {
  intl: IntlShape;
  confirmationDialog: boolean;
  handleCloseConfirmationDialog: any;
  handleValidate: any;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (
  props,
): JSX.Element => {
  return (
    <>
      <Dialog
        onClose={() => props.handleCloseConfirmationDialog()}
        aria-labelledby="simple-dialog-title"
        open={props.confirmationDialog}
      >
        <DialogTitle id="simple-dialog-title">
          <Grid container direction="row" justifyContent={'space-between'}>
            <Grid item xs={8}>
              {translate(messages.titleDialogCompletion, props)}
            </Grid>
            <Grid item>
              <CloseIconBlack
                onClick={() => props.handleCloseConfirmationDialog()}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container direction="column">
            <Grid item>
              <span style={StyleDescriptionDialog}>
                {translate(messages.confirmCompletionDialog, props)}
              </span>
            </Grid>
          </Grid>
        </DialogContent>
        <StyledDialogActions>
          <SecondaryButton
            onClick={() => props.handleCloseConfirmationDialog()}
            disableElevation
            data-testid="cancel-button"
            title={translate({ ...messages.dialogCancelButton }, props)}
            titlecolor={COLORS.PRIMARY_BUTTON_BLUE}
            border={COLORS.LIGHT_WHITE_GREY}
          />
          <PrimaryButton
            onClick={() => props.handleValidate()}
            disableElevation
            data-testid="validate-button"
            title={translate({ ...messages.dialogValidationButton }, props)}
            disabled={false}
            background={COLORS.PRIMARY_BUTTON_BLUE}
            titlecolor={COLORS.WHITE}
            border={COLORS.PRIMARY_BUTTON_BLUE}
          />
        </StyledDialogActions>
      </Dialog>
    </>
  );
};

export default injectIntl(ConfirmationDialog);
